import { IState } from 'types/location';
import { api } from '../api';

const servicesPrefix = 'state';

export const findAllStates = async (): Promise<IState[]> => {
  const { data } = await api.get<IState[]>(`${servicesPrefix}/findAll`);
  return data;
};
